import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel } from '../validation/Form-Components';
import appImgComplete from '../images/smappComplete.png';
import wclAppImgComplete from '../images/wclAppComplete.png';
import imgComplete from '../images/appComplete.png';
import imgPending from '../images/appHold.png';
import appImgPending from '../images/smappHold.png';
import hybridAppImgPending from '../hybridImages/appStatusPending.png';
import hybridAppImgComplete from '../hybridImages/appStatusComplete.png';
import wclAppImgPending from '../images/wclAppPending.png';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import config from '../appconfig/config.json';
import CusSavePrint from '../components/CusSavePrint';
import CusCancelApp from '../components/CusCancelApp';
import CusGreenBtn from '../components/CusGreenBtn';
import storage from '../factory/StorageFactory.js';
import LoadingText from '../components/LoadingText';
import mData from '../hybriddata/mainform.json';
import NonLendingSolutions from '../hybridcontainers/NonLendingSolutions.jsx';
import nldata from '../hybriddata/nonlendingdata.json';

const SubmitDetails = (props) => {

    const financeTypeIslamic = 'islamic';
    const financeTypeConventional = 'conventional';

    const applicantStatusComplete = 'submitted';
    const applicantStatusPending = 'pending';

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();

    const [completedApplicants, setCompletedApplicants] = useState([]);
    const [pendingApplicants, setPendingApplicants] = useState([]);

    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const [buttonPopup, setButtonPopup] = useState(false);
    const [isCancelling,setIsCancelling] = useState(false);
    const [showNonLending,setShowNonLending] = useState(true);

    useEffect(() => {
        console.log('@SubmitDetails useEffect');

        window.scrollTo(0, 0);
        getPropsData();
        //clearData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
        // console.log('getPropsData called');
        if (props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response : '';
            // console.log('getPropsData',resData)
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            getCompletedAndPendingPerson(resData);
            setIsLoading(false);
        }
        else {
            //redirect to error 
            console.log('error')
        }
    }

    const getInterestRate = () => {
        let tenure = parseInt(response.StatusDtls.Tenure);
        let rate = '';

        if (tenure > 1 && tenure <= 3) {
            rate = '10.88%';
        }
        else if (tenure > 3 && tenure <= 5) {
            rate = '12.88%';
        }

        return rate;
    }

    const getStatusData = () => {
        setIsLoading(true);
        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        service.getStatus(sid, rno).then(res => {
            let resData = res.data.model.fields.request;
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            getCompletedAndPendingPerson(resData);

            setIsLoading(false);
        })
        .catch(err => {
            console.log('err: ', err);
            setIsLoading(false);
        })
    }

    const showCompletionDateMsg = () => {
        let result = '';
        if (pendingApplicants.length !== 0) {  // pending
            if (response.SoleorNonSole === config.bizConst.Sole) {
                result = 'Please complete application before ' + response.StatusDtls.Deadline + ' to avoid re-applying';
            }
            else {
                //check if login user is the first user
                // if login user is first user, show sth.
                result = 'All directors/shareholders/business owners/partners to complete application before ' + response.StatusDtls.Deadline + ' to avoid re-applying'
            }
        }

        return result;

    }
    const getCompletedAndPendingPerson = (data) => {

        let completedArray = [], pendingArray = [];
        if (!Array.isArray(data.ApplicantsStatus)) {
            if (data.ApplicantsStatus.status.toLowerCase() === applicantStatusComplete) {
                completedArray.push(data.ApplicantsStatus)
            }
            else {
                pendingArray.push(data.ApplicantsStatus);
            }
        }
        else {
            for (let i in data.ApplicantsStatus) {

                if (data.ApplicantsStatus[i].status.toLowerCase() === applicantStatusComplete) {
                    completedArray.push(data.ApplicantsStatus[i]);
                }
                else {
                    pendingArray.push(data.ApplicantsStatus[i]);
                }
            }
        }

        setCompletedApplicants(completedArray);
        setPendingApplicants(pendingArray);
        setIsLoading(false);
    }

    //export and print pdf
    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: response.StatusDtls.ApplicationNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSStatusDetails');
        return url;
    }

    const handleCancelApplication = () => {
        //do cancel api here.
        setIsCancelling(true);
        service.cancel(refNo,uen).then(res => {
            setIsCancelling(false);
            if (res.data.isSucess) {
                //cancel success
                setButtonPopup(false);
                props.history.push(config.route.AppCancelled);
            }
        })
        .catch(err => {
            console.log('err: ', err);
            setIsCancelling(false);
        })
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    const showInterestRateLabel = () => {
        let fType = response.StatusDtls.FinancingType;
        if (fType.toLowerCase() === financeTypeConventional) {
            return 'Interest Rate (Indicative)';
           // return 'Interest Rate';
        }
        else {
            return 'Profit Rate (Indicative)';
            //return 'Profit Rate';
        }
    }

    const showFacility = () => {
        let fType = response.StatusDtls.FinancingType;
        if (fType.toLowerCase() === financeTypeConventional) {
            return true;
        }
        else {
            return false;
        }
    }

    const showDeadlineDate = () => {
        if(pendingApplicants.length !== 0 && response.StatusDtls.Deadline !== null) {
            return response.StatusDtls.Deadline;
        }
        return 'DDMMYYYY';
    }

    const isProductWCL = () => {
        if(response.StatusDtls.ProductType === 'WCL') {
            return true;
        }

        return false;
    }

    const isProductBTL = () => {
        if(response.StatusDtls.ProductType === config.bizFinancing.BTL) {
            return true;
        }
        return false;
    }

    const showProgressText = () => {
        let result = 'Submission in Progress';
        if(isProductBTL()) {
            result = 'Submission in Progress';
        }
        else {
            if(response.SoleorNonSole === config.bizConst.NonSole) {//Non Sole
                if(response.ApplicantsStatus.length > 1) {
                    result = 'Joint Application in Progress ('+completedApplicants.length+'/'+response.ApplicantsStatus.length+' Done)';
                }
                else {
                    result = 'Submission in Progress';
                }
            }
            else {
                result = 'Submission in Progress';
            }
        }
        return result;
    }

    const getPurposeString = () => {
        let result = '',temp = [];
        
        if(response.StatusDtls.WCL === 'Y') {
          temp.push(mData.label.chkWCL);
        }
        if(response.StatusDtls.Property === 'Y') {
          temp.push(mData.label.chkProperty);
        }
        if(response.StatusDtls.Trade === 'Y'){
          temp.push(mData.label.chkTrade);
        }
        if(response.StatusDtls.GAS === 'Y') {
          temp.push(mData.label.chkGAS);
        }
        if(response.StatusDtls.ESG === 'Y') {
            temp.push(mData.label.chkESG);
        }
        
      
        if(temp.length === 1) {
          result = temp[0];
        }
        else {
          result = temp.join(', ');
        }
        
        return result;
      }

      const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }

        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }

    const handleNonLendingActionDone = () => {
        storage.setShowNonLending(false);
        getStatusData();
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <div className="outerdivsubheader">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            {pendingApplicants.length === 0 ?
                                <div>
                                    {isProductWCL()?
                                    <>
                                    <h2 className='completeTitle1 mb-0'>{"Thank you for your interest in our SME e-Financing"}</h2>
                                    </>:
                                    <>
                                    {isProductBTL()?
                                    <>
                                    <h2 className='completeTitle1 mb-0'>{"Fantastic! You're one step away to growing your business."}</h2>
                                    <h2 className='completeTitle2'>{'Please look out for your application status update via email.'}</h2>
                                    </>
                                    :
                                    <>
                                    <h2 className='completeTitle1 mb-0'>
                                        {"Application submitted! Our sales team will be reaching out to you soon."}
                                    </h2>
                                    </>}
                                    </>
                                    }
                                </div>
                                :
                                <div>
                                    {response.SoleorNonSole === config.bizConst.NonSole ?
                                        <div>
                                            <h2 className='completeTitle1 mb-0'>{'We have received your application.'}</h2>
                                            <h2 className='completeTitle2'>
                                                {isProductBTL()?
                                                    <span>
                                                    {'All remaining owner(s) will receive an email/sms notification to review and complete the online application'}
                                                    </span>
                                                    :
                                                    <span>
                                                    {'Subsequent person(s) will receive an email/SMS notification to review and complete the online application.'}
                                                    </span>
                                                }
                                            </h2>
                                        </div> :
                                        <div>
                                            <h2 className='completeTitle1 mb-0'>{'Your online SME e-Financing application is currently on hold.'}</h2>
                                            <h2 className='completeTitle2'>{'You will receive email notification to review and complete the online application.'}</h2>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <img className="imgScc" src={pendingApplicants.length === 0 ? isProductBTL()? appImgComplete:hybridAppImgComplete : isProductBTL()? appImgPending:hybridAppImgPending} alt="imgScc1"></img>
                    </div>
                </FormContainer>

                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        {pendingApplicants.length === 0 ?
                            <h2 className='status-header-txt'>
                                {isProductWCL()?
                                    <>{'Our Relationship Manager will be in touch with you'}</>:
                                    <>{'We will email and SMS you our decision soonest'}</>
                                }
                            </h2> :
                            <h2 className='status-header-txt'>
                                {showProgressText()}
                            </h2>
                        }
                    </div>
                    <div style={{ textAlign: "center", justifyContent: 'space-evenly' }} >
                        {(pendingApplicants.length === 0) &&
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <img className="imgSccS1" src={imgComplete} alt="imgScc"></img><br />
                                    <div className="bbline">Application Complete</div><br />
                                    {completedApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        }

                        {(completedApplicants.length === 0) &&
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <img className="imgSccS1" src={imgPending} alt="imgScc"></img><br />
                                    <div className="bbline">Application Pending</div><br />
                                    {pendingApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        }

                        {(pendingApplicants.length !== 0 && completedApplicants.length !== 0) ?
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <img className="imgSccS1" src={imgComplete} alt="imgScc"></img><br />
                                    <div className="bbline">Application Complete</div><br />
                                    {completedApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <img className="imgSccS1" src={imgPending} alt="imgScc"></img><br />
                                    <div className="bbline">Application Pending</div><br />
                                    {pendingApplicants.map((item, idx) => (
                                        <div style={{ paddingTop: "1em", textAlign: 'center' }} key={idx}>
                                            {item.name}
                                        </div>
                                    ))
                                    }
                                </div>
                                
                            </div> : null
                        }
                    </div>

                    <div style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>
                    <div style={{ marginLeft: '25px', margingRight: '25px' }}>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                            id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                            id={'uen'} name={response.StatusDtls.UEN} />

                        {/* {showFacility() && */}
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                            id={'facility'} name={response.StatusDtls.Facility} />
                        {/* q} */}

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                            id={'financeType'} name={response.StatusDtls.FinancingType} />

                        {(response.StatusDtls.ProductType === config.bizFinancing.PBF) &&
                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={getPurposeString()} />
                        }

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                            id={'amt'} name={response.StatusDtls.Amount
                                ? response.StatusDtls.Amount != null
                                    ? 'SGD ' + parseFloat(response.StatusDtls.Amount)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : ""
                                : ""} />
                        {(response.StatusDtls.ProductType === config.bizFinancing.BTL) &&
                        <>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Tenure'}
                            id={'tenure'} name={response.StatusDtls.Tenure + ' years'} />
                        
                        {isProductWCL() === false &&   
                        <>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Instalment (Indicative)'}
                            id={'instalment'} name={'SGD ' + response.StatusDtls.Instalment} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={showInterestRateLabel()}
                            id={'interestRate'} name={response.StatusDtls.InterestRate + '%'} />
                        </>
                        }
                        </>
                        }
                        {(storage.getShowNonLending() !== 'true')&&
                        <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                            id={'combinedApp'} name={getNonLendingString()} />
                        }

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Date'}
                            id={'date'} name={response.StatusDtls.AppDate} />
                    </div>

                    <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>

                    {pendingApplicants.length !== 0 &&
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign:'center'}}>
                                <label className="box" id={'id77'}>Please complete application before {showDeadlineDate()} to avoid reapplying.</label>
                        </div>
                    </div>
                    }
                    
                    {pendingApplicants.length === 0 &&
                        <div style={{ textAlign: 'center', marginLeft: '20px', marginRight: '20px' }}>
                            <div style={{ color: 'gray', fontSize: '0.8em', fontWeight: 500 }}>{showCompletionDateMsg()}</div>
                        </div>
                    }

                    <br />

                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />

                    <div style={{ textAlign: "center" }} >
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome} />
                        <br />
                        <CusCancelApp onClick={() => setButtonPopup(true)} pTrigger={buttonPopup} psetTrigger={setButtonPopup}
                            backClick={() => {setButtonPopup(false);}} nextClick={handleCancelApplication} />
                    </div>
                    <br />

                    <LoadingText show={isCancelling} setShow={setIsCancelling} label={'Cancelling..'} />
                    
                    {(storage.getShowNonLending() === 'true') &&
                        <NonLendingSolutions trigger={showNonLending} setTrigger={setShowNonLending} response={response}
                        onActionDone={handleNonLendingActionDone}></NonLendingSolutions>
                    }
                </FormContainer>
                <br />
            </div>
        </PDFExport>
    )
}

export default SubmitDetails;